module.exports = __webpack_public_path__ + "img/poziom7.a4514eed.svg";